import { useTheme } from '@mui/material';

export default function AutomationIcon() {
  const theme = useTheme();
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z'
        fill={theme.palette.primary.light}
      />
      <path
        d='M20 15V20H23.75M27.5 20C27.5 20.9849 27.306 21.9602 26.9291 22.8701C26.5522 23.7801 25.9997 24.6069 25.3033 25.3033C24.6069 25.9997 23.7801 26.5522 22.8701 26.9291C21.9602 27.306 20.9849 27.5 20 27.5C19.0151 27.5 18.0398 27.306 17.1299 26.9291C16.2199 26.5522 15.3931 25.9997 14.6967 25.3033C14.0003 24.6069 13.4478 23.7801 13.0709 22.8701C12.694 21.9602 12.5 20.9849 12.5 20C12.5 18.0109 13.2902 16.1032 14.6967 14.6967C16.1032 13.2902 18.0109 12.5 20 12.5C21.9891 12.5 23.8968 13.2902 25.3033 14.6967C26.7098 16.1032 27.5 18.0109 27.5 20Z'
        stroke={theme.palette.primary.main}
        stroke-width='1.66667'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
